import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../components/auth/AuthContext'
import { CreatePasswordForm } from '../components/auth/CreatePasswordForm'
import toast from 'react-hot-toast'
import { authService } from '../services/authService'

interface CreatePasswordFormValues {
  newPassword: string
  confirmPassword: string
  email?: string
}

export const CreatePasswordPage = () => {
  const [showSuccessState, setShowSuccessState] = useState(false)
  const [passwordMismatch, setPasswordMismatch] = useState(false)
  const navigate = useNavigate()
  const { mustChangePassword, isLoading, refreshAuth } = useAuth()

  useEffect(() => {
    // Si el usuario no debe cambiar contraseña y no está en el estado de éxito, redirigir a dashboard
    if (!isLoading && !mustChangePassword && !showSuccessState) {
      navigate('/dashboard', { replace: true })
    }
  }, [mustChangePassword, isLoading, navigate, showSuccessState])

  const handleCreatePassword = async (values: CreatePasswordFormValues) => {
    try {
      setPasswordMismatch(false)

      // Validar que las contraseñas coincidan
      if (values.newPassword !== values.confirmPassword) {
        setPasswordMismatch(true)
        return
      }

      await authService.updatePassword(
        values.newPassword,
        values.confirmPassword
      )

      setShowSuccessState(true) // Primero muestra el éxito
      // NO llames refreshAuth aquí, espera a que el usuario haga click en el botón
    } catch (error: any) {
      console.error('Error al crear contraseña:', error)
      toast.error(
        error?.response?.data?.message || 'Error al crear la contraseña'
      )
    }
  }

  const handleInitiateProcess = () => {
    // Refresca el estado global y navega al dashboard después del proceso
    refreshAuth()
    toast.success('¡Proceso iniciado!')
    navigate('/onboarding/application-start')
  }

  return (
    <CreatePasswordForm
      onSubmit={handleCreatePassword}
      showSuccessState={showSuccessState}
      passwordMismatch={passwordMismatch}
      showEmailField={false}
      initialEmail=""
      onInitiateProcess={handleInitiateProcess}
    />
  )
}
